import { render } from "./HeaderImage.vue?vue&type=template&id=7cd7cba2&scoped=true&ts=true"
import script from "./HeaderImage.vue?vue&type=script&lang=ts"
export * from "./HeaderImage.vue?vue&type=script&lang=ts"

import "./HeaderImage.vue?vue&type=style&index=0&id=7cd7cba2&lang=scss&scoped=true"

import exportComponent from "/var/www/rewards/runners/app/root/reward-app/reward-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cd7cba2"]])

export default __exports__